import { LockSimpleIcon } from '@phosphor-icons/react'
import type { GateLocation } from 'app/types/workflow-gates'
import { SalesActions } from './LockPanel'

/** Above the canvas of a saved workflow that uses a product its location no longer has. The API
 *  pauses such a workflow (TRK-6192); this says why and who to talk to. */
export function ProductLockBanner({
  product,
  blockLabel,
  blockKind,
  location,
}: {
  product: string
  blockLabel: string
  blockKind: string
  location: GateLocation | undefined
}) {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-4 z-30 flex justify-center px-4">
      <div
        role="status"
        data-testid="workflow-product-lock-banner"
        className="pointer-events-auto flex max-w-full flex-wrap items-center gap-3 rounded-xl border border-default bg-surface py-2 pr-2 pl-3.5 shadow-lg"
      >
        <LockSimpleIcon className="size-4 shrink-0 text-subtle" aria-hidden />
        <p className="min-w-0 text-xs text-default">
          This workflow uses a product your location no longer has. To turn it back on, reach out to Trackable sales.
        </p>
        <SalesActions product={product} blockLabel={blockLabel} blockKind={blockKind} location={location} />
      </div>
    </div>
  )
}
